import React from 'react';
import useStyle from './quizCarouselSlide.style';
import { formatDate } from '../../../../helpers/date/formatDate';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { MyClassBlock } from 'components/molecules/Blocks/MyClassBlock';

export interface QuizCarouselSlideProps {
  startDate: Date;
  endDate: Date;
  remainingStudents: number;
  averageGrade: number;
  onClick: () => void;
}

export const QuizCarouselSlide = ({
  startDate,
  endDate,
  remainingStudents,
  averageGrade,
  onClick
}: QuizCarouselSlideProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div>
        <span>
          Du {formatDate(startDate)} au {formatDate(endDate)}
        </span>
      </div>
      {remainingStudents > 0 ? (
        <p className={classes.red}>
          {remainingStudents} personne
          {remainingStudents > 1 ? "s n'ont " : " n'a "}pas répondu à ce quiz
        </p>
      ) : (
        <p className={classes.green}>Tous les éléves ont répondu</p>
      )}
      <MyClassBlock
        title={'Moyenne de la classe'}
        text={averageGrade.toFixed(1) + ' / 20'}
        variant={'actuQuiz'}
      />
      <ButtonWithText
        variant="text"
        icon="Ranking"
        content="Résultats en détail"
        iconColor="#605E5E"
        onClick={onClick}
      />
    </div>
  );
};
